<template>
  <div id="book">book</div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
export default {
  mixins: [part],
  name: "book",
};
</script>

<style>
</style>